// src/utils/encryption.js
import CryptoJS from "crypto-js";



export const encryptData = (data) => {
  const stringifiedData =
    typeof data === "string" ? data : JSON.stringify(data);
  return CryptoJS.AES.encrypt(stringifiedData, process.env.REACT_APP_SECRET_KEY).toString();
};

export const decryptData = (encryptedData) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, process.env.REACT_APP_SECRET_KEY);
    const decryptedStr = bytes.toString(CryptoJS.enc.Utf8);

    if (!decryptedStr) {
      throw new Error("Empty string after decryption — wrong key?");
    }
    return JSON.parse(decryptedStr);
  } catch (error) {
    throw error;
  }
};
